<template>
	<page enable-flex>
		<c-scroll-list ref="list" class="flex-grow">
			<template #default="{data, index}">
				<div :key="index" class="item" @click="mp.navigateWeb('/feedback/detail', {id: data.id})">
					<div class="item-state flex-start-center">
						<div :style="{'color': data.status == 1 ? '#00A1E9' : '#00ACA9', 'background': data.status == 1 ? '#EBF8FD' : '#EBF8F8'}">{{data.status == 1 ? '处理中' : '已回复'}}</div>
					</div>
					<div class="item-message ellipsis">{{data.feedback_content}}</div>
					<div class="item-handle flex-between-center">
						<p>{{data.create_date}}</p>
						<p class="tf">&#xe6fd;</p>
					</div>
				</div>
			</template>
		</c-scroll-list>

		<template #button>
			<c-button size="form" color="main" @click="mp.navigateWeb('/feedback/edit')">我要投诉/建议</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		name: 'custom_complaints_proposals',
		
		mounted() {
			this.$refs.list.load({
				url: '/complaint/suggestion/list'
			});
			this.$onShow(() => {
				this.$refs.list.update();
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.item {
		border-radius: .12rem;
		padding: 0 .32rem;
		margin: .24rem .24rem 0;
		background: #fff;

		&-state {
			gap: .24rem;
			height: .8rem;
			padding: 0 .08rem;

			div {
				height: .4rem;
				padding: 0 .2rem;
				border-radius: .2rem;
				line-height: .4rem;
				font-size: .24rem;
			}
		}

		&-message {
			padding: 0 .08rem;
			line-height: .5rem;
			font-size: .3rem;
			color: #333;
		}

		&-handle {
			height: .8rem;
			border-top: .01rem solid #EAEDEE;
			margin-top: .2rem;
			font-size: .24rem;
			color: #999;
		}
	}
</style>